import { authFetch } from "@/plugins/axiosConfig";

const tradeStore = {
  namespaced: true,
  state: {
    isLoading: false,
    contents: [],
    pageInfo: {
      page: 0,
      totalPage: 0,
      size: 10,
      totalElements: 0,
    },
    cumulativeP: {
      LONG: [],
      SHORT: [],
    },
  },
  getters: {
    /* 리스트 조회 */
    GT_LIST: (state) => state.contents,
    /* 페이지 정보 조회 */
    GT_PAGE: (state) => state.pageInfo,
    /* 로딩 상황 조회 */
    GT_IS_LOADING: (state) => state.isLoading,
    /* 누적수익 LONG 조회 */
    GT_CUM_LONG: (state) => state.cumulativeP.LONG,
    /* 누적수익 SHORT 조회 */
    GT_CUM_SHORT: (state) => state.cumulativeP.SHORT,
  },
  mutations: {
    MU_DATA_UPDATE: (state, payload) => {
      state.pageInfo = {
        page: payload.page,
        totalPage: payload.totalPage,
        totalElements: payload.totalElements,
        size: 10,
      };
      state.contents = [...payload.contents];
      state.isLoading = false;
    },
    MU_ACTIVE_LOADING: (state) => {
      state.isLoading = true;
    },
    MU_INACTIVE_LOADING: (state) => {
      state.isLoading = false;
    },
    MU_CUM_ALL: (state, payload) => {
      state.cumulativeP.LONG = [];
      state.cumulativeP.SHORT = [];
      if (payload.length > 0) {
        payload.map((d) => {
          if (d.positionSide === "LONG") {
            state.cumulativeP.LONG = [...state.cumulativeP.LONG, { ...d }];
          } else if (d.positionSide === "SHORT") {
            state.cumulativeP.SHORT = [...state.cumulativeP.SHORT, { ...d }];
          }
        });
      }
    },
    MU_CUM_LONG: (state, payload) => {
      state.cumulativeP.LONG = [...payload];
    },
    MU_CUM_SHORT: (state, payload) => {
      state.cumulativeP.SHORT = [...payload];
    },
  },
  actions: {
    AT_GET_TRADE_HISTORY: async ({ commit }, payload) => {
      commit("MU_ACTIVE_LOADING");
      try {
        const response = await authFetch.get(
          `/api/asset/history/trade/${payload.symbol}/${
            payload.position
          }?page=${payload.page ? payload.page : 0}`
        );
        commit("MU_DATA_UPDATE", response.data);
      } catch (e) {
        console.log(e);

        commit("MU_INACTIVE_LOADING");
      }
    },
    /**
     * 사용자 트레이드 누적수익 계산
     * @param {*} param0
     */
    AT_GET_CUM_LIST: async ({ commit }) => {
      const endpoint = `/api/asset/history/group/sum`;

      const apiResponse = await authFetch.get(endpoint);

      if (apiResponse.status === 200) {
        const cumList = apiResponse.data;
        commit("MU_CUM_ALL", cumList);
      } else {
        console.log("error");
      }
    },
  },
};

export default tradeStore;
